import type {
  TextareaCustomEvent,
  TextareaChangeEventDetail,
} from '@ionic/react'
import { ParseKeys } from 'i18next'
import type { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParserI18nMessage } from '~/shared/lib/i18n'
import { IonTextarea } from './styled'

type TextareaInputProps = { name: string; label?: ParseKeys } & Omit<
  ComponentProps<typeof IonTextarea>,
  '$invalid'
>

export function TextareaInput({
  label,
  name,
  children,
  ...inputProps
}: TextareaInputProps) {
  const { t } = useTranslation()
  const { parserI18nMessage } = useParserI18nMessage()
  return (
    <Controller
      name={name}
      defaultValue=''
      render={({
        field: { onChange, value },
        fieldState: { error, invalid },
      }) => (
        <IonTextarea
          onIonInput={(e: TextareaCustomEvent<TextareaChangeEventDetail>) => {
            onChange(e.detail.value || '')
          }}
          value={value}
          name={name}
          label={label && t(label)}
          errorText={parserI18nMessage(
            error?.message || 'validate.required field',
          )}
          $invalid={invalid}
          {...inputProps}
        >
          {children}
        </IonTextarea>
      )}
    />
  )
}
